__turbopack_context__.v({
  "codeInput": "KU4hHG_codeInput",
  "hyphen": "KU4hHG_hyphen",
  "inputContainer": "KU4hHG_inputContainer",
  "inputGroup": "KU4hHG_inputGroup",
  "srOnly": "KU4hHG_srOnly",
});
